import { Button, styled } from "@mui/material";

export const StyledButton = styled(Button)(({ theme }) => ({
  height: "50px",
}));


export const ActionButtonSx = {
  display: "flex",
  alignItems: "center",
  gap: 1,
  padding: "8px 16px",
  borderRadius: "8px",
  backgroundColor: "#F9FAFB",
  border: "1px solid #E5E7EB",
  cursor: "pointer",
  transition: "all 0.2s ease",
  "&:hover": {
    backgroundColor: "#F3F4F6",
    borderColor: "#D1D5DB",
  },
};

/** Matches StudySidebar tracking counter / dot badge (#F05252). */
export const FilterActiveDotBadgeSx = {
  "& .MuiBadge-badge": {
    backgroundColor: "#F05252",
  },
};